import { Component } from '@angular/core';

@Component({
    selector: 'app-invalid-divison-plant-report',
    imports: [],
    templateUrl: './invalid-divison-plant-report.component.html',
    styleUrl: './invalid-divison-plant-report.component.scss'
})
export class InvalidDivisonPlantReportComponent {

}
